import { NavLink } from 'react-router-dom';
import { Image, SemanticCOLORS } from 'semantic-ui-react';

import './MainHeader.css';

import Dragonfly_Logo from '../../assets/Dragonfly_Advise_logo.svg';
import HelpModal from './components/HelpModal';
import NavigationMenuBar from './components/NavigationMenuBar';
import SignInMenu from './components/SignInMenu';
import UserMenu from './components/UserMenu';
import { TeamStats, UserRole } from './MainHeader.types';

interface MainHeaderProps {
  username: string;
  handleProfileClick: () => void;
  handleLogoutClick: () => void;
  userGuideUrl: string;
  handleAutoAssignClick: () => void;
  userRoles: UserRole[];
  teamStats: TeamStats[];
  totalPending: number;
  colors: SemanticCOLORS[];
  iamworking: boolean;
  userToken?: string | null;
}

const MainHeader = ({
  username,
  handleProfileClick,
  handleLogoutClick,
  userGuideUrl,
  handleAutoAssignClick,
  userRoles,
  teamStats,
  totalPending,
  colors,
  iamworking,
  userToken,
}: MainHeaderProps) => {
  return userToken ? (
    <>
      <div className='header-logo' id='main-logo-header'>
        <NavLink to='/'>
          <Image
            style={{
              display: 'inline',
              paddingLeft: '65px',
              zIndex: '10',
            }}
            src={Dragonfly_Logo}
          />
        </NavLink>
        <div>
          <UserMenu
            username={username}
            handleProfileClick={handleProfileClick}
            handleLogoutClick={handleLogoutClick}
          />
          <HelpModal userGuideUrl={userGuideUrl} />
        </div>
      </div>
      <NavigationMenuBar
        userRoles={userRoles}
        teamStats={teamStats}
        totalPending={totalPending}
        colors={colors}
        iamworking={iamworking}
        handleAutoAssignClick={handleAutoAssignClick}
        username={username}
        handleProfileClick={handleProfileClick}
        handleLogoutClick={handleLogoutClick}
      />
    </>
  ) : (
    <SignInMenu />
  );
};

export default MainHeader;
